export default __webpack_public_path__ + "static/media/Otherservice.6b3f6011.webp";